export default function Legend() {
  return (
    <div className="absolute bottom-3 left-3 z-10 px-2 py-1 rounded bg-neutral-900/70 text-xs flex gap-3">
      <span><span className="inline-block w-2 h-2 rounded-full mr-1" style={{background:'#4A90E2'}}></span>Imperium</span>
      <span><span className="inline-block w-2 h-2 rounded-full mr-1" style={{background:'#E24A4A'}}></span>Chaos</span>
      <span><span className="inline-block w-2 h-2 rounded-full mr-1" style={{background:'#77C159'}}></span>Xenos</span>
      <span><span className="inline-block w-2 h-2 rounded-full mr-1" style={{background:'#B0B0B0'}}></span>Other</span>
    </div>
  );
}

